<template>
  <section class="content-current section-header">
    <div class="card-header">
      <h4>
        <span
          style="
            color: rgb(210 42 42);
            font-weight: 600;
            text-align: center;
            font-size: 20px;
          "
          >{{ errorMessage }}</span
        >
      </h4>
    </div>

    <hr />
    <div class="btn-align">
      <button type="submit" class="btn-profile" @click.prevent="backToSearch()">
        بازگشت به صفحه جستجو
      </button>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      providerId: "",
    };
  },
  created() {
    this.providerName = this.$route.params.providerName;
    this.errorMessage = this.$route.params.errorMessage;
  },
  methods: {
    backToSearch() {
      this.$router
        .push({
          path: "/tourism/tourismSearch/" + this.providerName,
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.content-current {
  min-height: 300px;
}
.section-header {
  margin-top: 60px;
  margin-bottom: 60px;
}
.card-header {
  padding: 4.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgb(235 20 20 / 3%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  text-align: center;
}
.btn-profile {
  width: 220px;
}
.btn-align {
  clear: both;
  text-align: center;
  margin: 35px;
}
</style>